import React from "react";
import { observer } from "mobx-react-lite";
import { mainStore } from "../../mainStore";
import "./styles.scss";

export const OddsHistorySection = observer(() => {
  return (
    <div className="odds-container">
      {mainStore.oddsHistory.map((odd, index) => (
        <div
          key={index + Math.random()}
          className={`odd-item ${odd.win !== undefined ? (odd.win ? "win" : "lose") : ""} ${odd.className ?? ""}`}
        >
          {odd.text}
        </div>
      ))}
    </div>
  );
});
